import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import { AuthService } from 'app/service/auth/auth.service';
import { CommonService } from 'app/shared/common.service';
import { GlobalService } from 'app/shared/global.service';
import { SetRights } from 'app/shared/set-rights';
import { ToastrService } from 'ngx-toastr';
import { saveChangePassword } from './change-password.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  hide = true;
  hide1 = true;
  hide2 = true;

  ClientID: number = 0;
  LocationID: number = 0;
  ComponentID: number = 0;
  UserID: number = 0;
  Add: boolean = false;
  Delete: boolean = false;
  Modify = false;
  View: boolean = false;
  messages: {};
  isInProgress;

  itemToEdit = {
    'UserName': this.globals.UserEmail,
    'Password': ''
  };
  itemToEditChangePassword = {
    'UserName': this.globals.UserEmail,
    'OldPassword': '',
    'NewPassword': '',
    'ConfirmPassword': ''
  };
  constructor(public globals: GlobalService,
    private pageTitleService: PageTitleService,
    public translate: TranslateService,
    private toasterService: ToastrService,
    public savechangepassword: saveChangePassword,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService) {

  }
  // Getting ComponentID
  GetComponentID() {
    const ComponentName = this.route.snapshot.routeConfig.path;
    const Component = this.globals.VisibleComponentMenu[ComponentName];
    if (Component) {
      this.ComponentID = Component["ComponentID"];
      this.globals.ComponentID = this.ComponentID;
      this.ClientID = this.globals.ClientID;
      this.LocationID = this.globals.LocationID;
      this.UserID = this.globals.UserID;
      this.messages = this.globals.messages;

    }
  }

  // Getting Components Rights
  getComponentRights(AuthenticationType) {
    const setRight = new SetRights();
    const rights: string[] = setRight.setRight(AuthenticationType).split(",");
    this.Add = rights[0].toLowerCase() == 'true' ? true : false;
    this.Modify = rights[1].toLowerCase() == 'true' ? true : false;
    this.Delete = rights[2].toLowerCase() == 'true' ? true : false;
    this.View = rights[3].toLowerCase() == 'true' ? true : false;



    // Setting Default Values For Global Service
    this.globals.SetDefaultValuesForGlobal();

    // Checking Token Value Is There Or Not
    if (sessionStorage.getItem('token') !== null) {
      sessionStorage.removeItem('token');
    }
    // Checking Settings Value Is There Or Not
    if (sessionStorage.getItem('settings') !== null) {
      // Removing Settings
      sessionStorage.removeItem('settings');
    }
  }


  // This method used for Change New Password
  saveChangePassword() {
    this.isInProgress = true;
    if (this.itemToEditChangePassword.OldPassword == '' || this.itemToEditChangePassword.NewPassword == ''
      || this.itemToEditChangePassword.ConfirmPassword == '') {
      this.isInProgress = false;
      this.toasterService.warning(' All Fields are mandatory.');
    } else {
      if (this.itemToEditChangePassword.NewPassword !== this.itemToEditChangePassword.ConfirmPassword) {
        this.isInProgress = false;
        this.toasterService.warning("New Password and Confirm Password is Mismatch!!");
      } else {
        this.savechangepassword.saveChangePassword(this.itemToEditChangePassword).subscribe(data => {
          if (data == "OK") {
            this.LogOut();
            this.router.navigate(['/session/booking/booking']);
            this.toasterService.success("Password change successful!");
            this.Clear();
          } else if (data == "Unmatch") {
            this.toasterService.warning("Old Password Mismatch!!");
            // this.Clear();
          } else if (data == "Failed") {
            this.toasterService.warning("Something went wrong!!");
          } else {
            this.toasterService.warning("Something went wrong!!");
          }
          this.isInProgress = false;
        });
      }
    }
  }

  // Clearing entered data
  Clear() {
    this.itemToEditChangePassword.OldPassword = '';
    this.itemToEditChangePassword.NewPassword = '';
    this.itemToEditChangePassword.ConfirmPassword = '';
  }

  // Getting Checked Is User Token Same Or Not
  GetCheckUserTokenValidOrNot() {
    this.commonService.GetCheckUserTokenValidOrNot().subscribe((result) => {
      if (result) {
        // Getting Token Expires Or Not
        const tokenExpires = this.authService.isTokenExpired();
        if (tokenExpires) {
          // Token Expires
          // Getting New Token
          this.GetRefreshToken();

          // Getting Checked Is User Token Same Or Not
          this.GetCheckUserTokenValidOrNot();
        } else {
          // Getting Token Expires Or Not
          // Token Is Valid
          // Getting Component Details
          this.GetComponentID();
        }
      } else {
        // Token is not same so loggin out user
        this.authService.logOut();
      }
    });
  }

  // Getting Refresh Token
  GetRefreshToken(): void {
    this.authService.getRefreshToken().subscribe((data) => {
      if (data != null || data != "") {
        this.authService.setToken(data);
      } else {
        this.authService.logOut();
      }
    });
  }

  ngOnInit(): void {
    // Using translate for transation using selected language
    this.translate.get("Change password").subscribe((res: string) => {
      // Sending translated for header
      this.pageTitleService.setTitle(res);

      // Getting Checked Is User Token Same Or Not
      this.GetCheckUserTokenValidOrNot();
    });

  }

  LogOut() {
    this.authService.logOut();
    this.globals.UserName = '';
    this.globals.UserEmail = '';
    this.globals.UserID = 0;
    this.router.navigate(['/session/booking-login/booking-login-register']);
  }
}
